module.exports = __webpack_public_path__ + "img/1121842666.a6f61aa7.png";